/**
 * Load organization.app settings for the actor's membership org.
 * Used by invoice default inheritance — never the platform default org pointer.
 */

import { supabase } from "../supabase";
import { getOrganization } from "./organizationHelpers";
import { organizationRowToAppSettings } from "./organizationSettings";
import { resolveOrganizationIdForQueries } from "./orgQueryScope";

export async function loadActorOrganizationSettings(
  actor,
  client = supabase,
) {
  const organizationId = await resolveOrganizationIdForQueries(actor, client);
  if (!organizationId) {
    return null;
  }

  const row = await getOrganization(organizationId, client);
  if (!row) {
    return null;
  }

  return organizationRowToAppSettings(row);
}
